import { useEffect } from "react";
import { useQueryClient } from "react-query";
import { pos, sessionTransport } from "@/platform";
import { useAuthUser } from "@/context/auth/AuthContext";
import { prepareSession, renewSession } from "@/context/auth/sessionRenewal";
import { asegurarLatido } from "@/context/caja/latidoDeLaCaja";
import { TERMINAL_DEL_EQUIPO_QUERY_KEY } from "@/hooks/react-query/Caja/useTerminalDelEquipo";

/**
 * Late por la caja del negocio de la sesión (#344 AC-2). Sólo en el escritorio,
 * y sólo si el equipo es una caja: lo decide Rust en cada latido.
 */
export function useLatidoDeLaCaja() {
  const businessId = useAuthUser()?.businessId as string | undefined;
  const qc = useQueryClient();

  useEffect(() => {
    if (!pos.isAvailable) return;
    void asegurarLatido(businessId ?? null, {
      pos,
      bffUrl: import.meta.env.VITE_BFF_URL,
      renovarSesion: async () => {
        const sesion = await prepareSession(sessionTransport);
        if (!sesion.token) return;
        await renewSession(sessionTransport, sesion);
      },
      alCambiarLaBaja: () =>
        void qc.invalidateQueries(TERMINAL_DEL_EQUIPO_QUERY_KEY),
    }).catch(() => {
      // Sin latido, la caja dice «Conectando…» y vende como siempre.
    });
  }, [businessId, qc]);
}
